module.exports = __webpack_public_path__ + "static/gallery15-cfee5af6a253d6f20d64660024c516fa.png";